import React, { createContext, useContext, ReactNode } from "react";

export interface AnalyticsContextValue {
    track(event: string, data?: Record<string, unknown>): void;
}

const AnalyticsContext = createContext<AnalyticsContextValue>({ track: () => {} });

/**
 * Provides a shared `track` function to all descendant components.
 *
 * Each app wires this once at the root:
 * - Core app: delegates to `window.eventTracker.event()`
 * - Rapid: delegates to Rapid's own `useAnalytics().track()`
 */
export function SharedAnalyticsProvider({
    track,
    children
}: {
    track: (event: string, data?: Record<string, unknown>) => void;
    children: ReactNode;
}) {
    return <AnalyticsContext.Provider value={{ track }}>{children}</AnalyticsContext.Provider>;
}

export function useSharedAnalytics(): AnalyticsContextValue {
    return useContext(AnalyticsContext);
}
